var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgServiceIcon4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#service-icon-4_svg__a)",
  d: "M2 14V5h14a6 6 0 0 1 6 6v7H6a4 4 0 0 1-4-4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4A",
  d: "m12.834 18 3.667-13H18a4 4 0 0 1 4 4v9z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M5.91 7a.465.465 0 0 0-.465.465v1.09H4.263a.444.444 0 1 0 0 .888h1.182v1.092a.465.465 0 1 0 .929 0V9.443h1.182a.444.444 0 0 0 0-.889H6.374v-1.09A.465.465 0 0 0 5.909 7",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "service-icon-4_svg__a",
  x1: 23.5,
  x2: 2,
  y1: 18,
  y2: 18,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4EDFC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#568DFE"
})))));
export default SvgServiceIcon4;